/*
 *
 * Coupon actions
 *
 */

import { createAction } from '@reduxjs/toolkit';
import {
  CREATE_COUPON,
  DELETE_COUPON,
  GET_COUPONS,
  RESET_GET_COUPONS,
  UPDATE_COUPON,
} from './constants';

export const getCouponsAct = createAction(
  GET_COUPONS,
  (loadingState, params, data) => ({
    payload: {
      loadingState,
      params,
      data,
    },
  }),
);

export const createCouponAct = createAction(
  CREATE_COUPON,
  (loadingState, data) => ({
    payload: {
      loadingState,
      data,
    },
  }),
);

export const updateCouponAct = createAction(
  UPDATE_COUPON,
  (loadingState, id, data) => ({
    payload: {
      loadingState,
      id,
      data,
    },
  }),
);

export const deleteCouponAct = createAction(
  DELETE_COUPON,
  (loadingState, id) => ({
    payload: {
      loadingState,
      id,
    },
  }),
);

export const resetGetCoupons = createAction(RESET_GET_COUPONS);
